import {forwardRef, useImperativeHandle, useState} from 'react';
import {useSelector} from 'react-redux';
import {agylePref} from '../../../../store/reducers/preferences';
import {OPTION_BUTTONS_DEFAULT_GAP, useSettingsStyles} from '../userProperties';
import {useTranslation} from 'react-i18next';
import {Chip, FormLabel, Stack} from '@mui/material';
import clsx from 'clsx';
import {isNull} from 'lodash';
import {isMobile} from 'react-device-detect';

const DEFAULT_STATE = {
    timestampsDisplay: 'close',
};

const TimestampsDisplay = forwardRef((props, ref) => {
    const classes = useSettingsStyles();
    const {t} = useTranslation();
    const agylePreference = useSelector(agylePref);

    const [mode, setMode] = useState(!isNull(agylePreference?.timestampsDisplay) ? agylePreference?.timestampsDisplay : DEFAULT_STATE.timestampsDisplay);

    // Return default state of a component
    useImperativeHandle(ref, () => ({
        defaultState: () => {
            setMode(DEFAULT_STATE.timestampsDisplay);
            return DEFAULT_STATE;
        },
    }));

    const handleChange = (val) => {
        setMode(val);
        props.onChange('timestampsDisplay', val);
    };

    return (
        <div>
            <FormLabel>
                {t('Select the default behaviour of timestamps display option')}
            </FormLabel>

            <Stack direction='row' gap={OPTION_BUTTONS_DEFAULT_GAP} sx={{mt: 1, my: .5}}>
                <Chip disabled={isMobile} label="Auto - remembers last state" className={clsx(mode === 'auto' && classes.activeChip)} onClick={handleChange.bind(null, 'auto')} />

                <Chip disabled={isMobile} label="Always Open" className={clsx(mode === 'open' && classes.activeChip)} onClick={handleChange.bind(null, 'open')} />

                <Chip disabled={isMobile} label="Always Closed" className={clsx(mode === 'close' && classes.activeChip)} onClick={handleChange.bind(null, 'close')} />
            </Stack>
        </div>
    );
});

export default TimestampsDisplay;